/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Take_ActionInputs */

const en_header_take_action = /** @type {(inputs: Header_Take_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take Action/Join`)
};

/**
* | output |
* | --- |
* | "Take Action/Join" |
*
* @param {Header_Take_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_take_action = /** @type {((inputs?: Header_Take_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Take_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_take_action(inputs)
});